var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP20Tip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 254,
    viewBox: "0 0 25 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3771 192.673H10.2878C10.02 192.673 9.80566 192.419 9.80566 192.101V184.673H15.8057V192.101C15.8057 192.419 15.5914 192.673 15.3771 192.673Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.80566 122.673H12.8057L12.8057 167.673H8.80566C8.80566 167.673 8.23424 138.873 4.80566 122.673Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8057 122.673H12.8057L12.8057 167.673H16.8057C16.8057 167.673 17.3771 138.873 20.8057 122.673Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80566 123.673H16.8057L16.8057 186.673C16.8057 187.777 15.9102 188.673 14.8057 188.673H10.8057C9.70109 188.673 8.80566 187.777 8.80566 186.673L8.80566 123.673Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8057 106.673H2.80566V122.673C2.80566 123.777 7.28282 124.673 12.8057 124.673C18.3285 124.673 22.8057 123.777 22.8057 122.673V106.673Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8025 109.626V27.6727C24.8025 26.2653 24.0483 25.5795 22.8142 24.9763L18.4262 22.8317L12.8726 20.2179L6.70203 23.1668L2.86254 24.9763C1.55985 25.5795 0.805664 26.7859 0.805664 28.1933L0.805664 109.673C0.805664 110.777 6.17825 111.673 12.8057 111.673C19.4331 111.673 24.8057 110.777 24.8057 109.673C24.8057 109.657 24.8046 109.642 24.8025 109.626Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 25,
    height: 92
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8025 109.626V27.6727C24.8025 26.2653 24.0483 25.5795 22.8142 24.9763L18.4262 22.8317L12.8726 20.2179L6.70203 23.1668L2.86254 24.9763C1.55985 25.5795 0.805664 26.7859 0.805664 28.1933L0.805664 109.673C0.805664 110.777 6.17825 111.673 12.8057 111.673C19.4331 111.673 24.8057 110.777 24.8057 109.673C24.8057 109.657 24.8046 109.642 24.8025 109.626Z",
    fill: "#F5F7F9"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.805664,
    y: 24.6727,
    width: 6,
    height: 87,
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.8057,
    y: 24.6727,
    width: 6,
    height: 87,
    fill: "#E5ECF0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.8722 20.6207C15.4471 20.6207 17.5345 19.8105 17.5345 18.8111C17.5345 17.8117 15.4471 17.0016 12.8722 17.0016C10.2973 17.0016 8.20996 17.8117 8.20996 18.8111C8.20996 19.8105 10.2973 20.6207 12.8722 20.6207Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6474 21.6924C20.2762 19.5477 18.1508 17.9392 15.7511 17.269C15.2711 17.6041 14.1741 17.8052 12.8029 17.8052C11.5002 17.8052 10.4718 17.6041 9.92326 17.3361C7.52358 18.0733 5.32958 19.5477 3.95833 21.7594C3.47839 22.5636 3.27271 23.5689 3.27271 24.5072V33.689C3.27271 34.4262 3.95833 34.9624 4.71252 34.8954C6.97508 34.4933 9.64901 34.2252 12.5972 34.2252C15.7511 34.2252 18.4936 34.4933 20.8932 34.8954C21.6474 35.0294 22.3331 34.4933 22.3331 33.689V24.3732C22.3331 23.4349 22.1274 22.4966 21.6474 21.6924Z",
    fill: "#F7DD89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23706 23.234C5.19693 21.9606 6.56818 21.0223 8.00799 20.2851C8.76218 19.95 9.51637 19.6819 10.3391 19.4809C11.1619 19.2798 11.9846 19.2128 12.8074 19.2128C14.4529 19.2128 16.1669 19.5479 17.6067 20.2851C19.1151 20.9553 20.4178 21.9606 21.3777 23.234C20.0064 22.3627 18.6352 21.6925 17.1954 21.2234C16.4412 21.0223 15.7555 20.8213 15.0014 20.6872C14.2472 20.5532 13.493 20.4862 12.7388 20.4862C11.2304 20.4862 9.72205 20.7542 8.28224 21.1564C6.97956 21.6925 5.53975 22.3627 4.23706 23.234Z",
    fill: "#D5B85C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8057 55.6727H8.80566V83.5842H16.8057V55.6727Z",
    fill: "#F7DD89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1335 61.3058H10.5752V77.5315H15.1335V61.3058Z",
    fill: "#FBF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1335 61.3058H10.5752V61.6421H15.1335V61.3058Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1335 77.2792H10.5752V77.6155H15.1335V77.2792Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1335 71.9824H10.5752V72.3187H15.1335V71.9824Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1335 66.6021H10.5752V66.9383H15.1335V66.6021Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9239 62.911C13.2262 62.911 13.4663 62.9947 13.644 63.162C13.8233 63.3279 13.9129 63.5495 13.9129 63.8269C13.9129 64.0383 13.8461 64.2673 13.7124 64.5139C13.5802 64.7605 13.347 65.087 13.0128 65.4936H14.1043V66.0264H12.042V65.9626C12.282 65.6764 12.4879 65.4195 12.6596 65.192C12.8327 64.963 12.9664 64.7737 13.0606 64.6239C13.1548 64.4728 13.2217 64.3443 13.2612 64.2386C13.3007 64.133 13.3204 64.0236 13.3204 63.9106C13.3204 63.7697 13.2733 63.6515 13.1791 63.5561C13.0865 63.4592 12.9733 63.4108 12.8396 63.4108C12.5995 63.4108 12.3504 63.5429 12.0921 63.8071V63.2038C12.3641 63.0086 12.6413 62.911 12.9239 62.911Z",
    fill: "#101620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.088 68.1796C13.4101 68.1796 13.6653 68.3197 13.8537 68.6001C14.0436 68.8804 14.1385 69.2635 14.1385 69.7494C14.1385 70.2396 14.0451 70.6264 13.8582 70.9097C13.6714 71.193 13.4161 71.3346 13.0925 71.3346C12.7644 71.3346 12.5046 71.1945 12.3132 70.9141C12.1233 70.6323 12.0283 70.247 12.0283 69.7582C12.0283 69.2709 12.1233 68.8863 12.3132 68.6045C12.5031 68.3212 12.7613 68.1796 13.088 68.1796ZM12.6208 69.7758C12.6208 70.4789 12.7765 70.8304 13.088 70.8304C13.3918 70.8304 13.5437 70.4605 13.5437 69.7208C13.5437 69.0294 13.3903 68.6838 13.0834 68.6838C12.775 68.6838 12.6208 69.0478 12.6208 69.7758Z",
    fill: "#101620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0938 73.4186C13.4159 73.4186 13.6711 73.5588 13.8595 73.8391C14.0494 74.1195 14.1444 74.5026 14.1444 74.9884C14.1444 75.4787 14.0509 75.8654 13.8641 76.1487C13.6772 76.432 13.422 76.5736 13.0984 76.5736C12.7702 76.5736 12.5105 76.4335 12.319 76.1531C12.1291 75.8713 12.0342 75.486 12.0342 74.9972C12.0342 74.5099 12.1291 74.1253 12.319 73.8435C12.5089 73.5602 12.7672 73.4186 13.0938 73.4186ZM12.6267 75.0148C12.6267 75.7179 12.7824 76.0695 13.0938 76.0695C13.3977 76.0695 13.5496 75.6996 13.5496 74.9598C13.5496 74.2684 13.3962 73.9228 13.0893 73.9228C12.7809 73.9228 12.6267 74.2868 12.6267 75.0148Z",
    fill: "#DB0300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2667 24.7082V33.6889C22.2667 34.4262 21.6496 34.9623 20.8269 34.8283C20.0727 34.6942 19.25 34.6272 18.3586 34.4932V23.0997C19.4556 23.5019 20.0727 23.837 21.0326 24.2391C21.7868 24.4401 21.7868 24.4401 22.2667 24.7082Z",
    fill: "#E9CE78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34277 24.7103V33.691C3.34277 34.4282 3.95984 34.9644 4.78258 34.8304C5.53677 34.6963 6.35952 34.6293 7.25083 34.4953V23.1018C6.15383 23.5039 5.53677 23.839 4.5769 24.2411C3.82271 24.4422 3.82271 24.4422 3.34277 24.7103Z",
    fill: "#E9CE78"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M7.80005 187L17.8 187L17.8 189L7.80005 189L7.80005 187Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 187,
    width: 10,
    height: 65
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30029 187L17.3004 187L16.8003 204L16.2512 204L15.8002 213L15.2618 213L13.8003 251.004L11.8003 251.001L10.3388 213L9.80022 213L9.35034 204L8.8003 204L8.30029 187Z",
    fill: "#F7EFC7"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M7.80054 187.027L17.8004 186.972L17.3381 203.975L8.44936 204.024L7.80054 187.027Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M7.88818 203.027L17.888 202.972L17.6727 212.973L8.21332 213.025L7.88818 203.027Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M9.93774 212.016L15.9377 211.983L14.1517 250.993L12.1517 251.004L9.93774 212.016Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3002 251.001L10.306 188.013L8.30601 188.024L7.8004 251.01L12.3002 251.001Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3001 250.996L15.3058 187.986L17.3057 187.975L17.8001 250.996L13.3001 250.996Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8005 189L7.80029 189L7.81177 190.027L17.8003 190L17.8005 189ZM8.04634 204.026L16.8937 203.977L16.8686 204.978L7.89929 205.027L8.04634 204.026ZM10.0431 213.015L15.8431 212.983L15.8285 213.983L9.94864 214.016L10.0431 213.015Z",
    fill: "#333333"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -2.19434,
    y: -1,
    width: 30,
    height: 259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 253,
    fill: "white",
    transform: "translate(0.805664)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 64,
    fill: "white",
    transform: "translate(7.80029 187)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP20Tip);
export default __webpack_public_path__ + "static/media/P20-Tip.bf1cc2af34c7d44a9b72a436fd732715.svg";
export { ForwardRef as ReactComponent };